// 定义一个全局过滤器
import Vue from 'vue'

//日期过滤
Vue.filter('dateFormat', function (val, fmt = '') {
    if (!val)
        return ''
    let date = val
    if (typeof val == 'string') {
        date = new Date(Date.parse(val.replace(/-/g, '/').replace(/T/g, ' ')));// new Date(val)
    }
    if (typeof val == 'number') {
        date = new Date(date)
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
})
function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

//秒转time
Vue.filter('secondToDate', function (val) {
    if (!val)
        return '00:00:00'
    let seconds = val
    if (typeof val == 'string') {
        seconds = parseInt(seconds)
    }
    if (typeof val == 'number') {
        seconds = val
    }
    var h = Math.floor(seconds / 3600) < 10 ? '0' + Math.floor(seconds / 3600) : Math.floor(seconds / 3600);
    var m = Math.floor((seconds / 60 % 60)) < 10 ? '0' + Math.floor((seconds / 60 % 60)) : Math.floor((seconds / 60 % 60));
    var s = Math.floor((seconds % 60)) < 10 ? '0' + Math.floor((seconds % 60)) : Math.floor((seconds % 60));
    return seconds = h + ':' + m + ':' + s;
})

//存储大小格式化 size 单位b
Vue.filter('sizeFormat', function (val) {
    if (!val)
        return '0';

    var num = 1024.00;
    if (val < num)
        return val + 'B';
    if (val < Math.pow(num, 2))
        return (val / num).toFixed(1) + 'KB';
    if (val < Math.pow(num, 3))
        return (val / Math.pow(num, 2)).toFixed(1) + 'M';
    if (val < Math.pow(num, 4)) {
        return (val / Math.pow(num, 3)).toFixed(1) + 'G';
    }
    return (val / Math.pow(num, 4)).toFixed(1) + 'T';
})


// let filters = {
//     dateFormat: function (val, fmt = '') {
//         console.log(fmt)
//         if (!val)
//             return ''
//         let date = val
//         if (typeof val == 'string') {
//             date = new Date(Date.parse(val.replace(/-/g, '/').replace(/T/g, ' ')));// new Date(val)
//         }
//         if (typeof val == 'number') {
//             date = new Date(date)
//         }
//         if (/(y+)/.test(fmt)) {
//             fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
//         }
//         let o = {
//             'M+': date.getMonth() + 1,
//             'd+': date.getDate(),
//             'h+': date.getHours(),
//             'm+': date.getMinutes(),
//             's+': date.getSeconds()
//         };
//         for (let k in o) {
//             if (new RegExp(`(${k})`).test(fmt)) {
//                 let str = o[k] + '';
//                 fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
//             }
//         }
//         return fmt;
//     }
// }

// export default (Vue) => {
//     Object.keys(filters).forEach(key => {
//         Vue.filter(key, filters[key])
//     })
// }

// export default () => {
//     filters
// }